export default "__VITE_ASSET__698fff81__"